import React from 'react';
import { usePopperTooltip } from 'react-popper-tooltip';
import 'react-popper-tooltip/dist/styles.css';

const Tooltip = ({ children, tooltip, placement, ...props }) => {
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible,
  } = usePopperTooltip({ placement });

  return (
    <div
      {...props}
    >
      {visible && (
        <div
          ref={setTooltipRef}
          {...getTooltipProps({ className: "tooltip-container" })}
        >
          <div {...getArrowProps({ className: 'tooltip-arrow', 'data-placement': placement })} />
          {tooltip}
        </div>
      )}
      <span ref={setTriggerRef}>
        {children}
      </span>
    </div>
  )
};

export default Tooltip;
